/* ==========================================================================
   Bearly Tools — mobile soft ask — assets/bearly-tools-mobile-ask.js
   Loaded (deferred) by snippets/tool-shell.liquid right after bearly-tools-core.js.

   Phones only. For tools that work best on a computer:
     1. On load, one of two styles (mobile_ask_copy line 4):
        "cover" (default) — a full-screen white-out: "This tool works best on a computer",
          email box, "Email me the link", and a big "Try it on my phone". Once per visit.
        "bar" — a slim strip that folds away as soon as the visitor starts using the tool.
     2. A card when someone opens the file picker and backs out without a file
        ("no file on this phone?") — once per visit.
   Either one collects an email, subscribes it to the tool list (fail-open, 4s cap),
   unlocks every tool's download gate, and sends the Klaviyo event
   "Requested Tool Link" (tool, tool_url) that the link email flow is triggered by.

   On/off + wording per tool: bearly_tool metaobject
     mobile_ask_enabled  (boolean)
     mobile_ask_copy     (list) line 1 = headline / bar text, line 2 = button,
                         line 3 = no-file card text, line 4 = style: cover | bar
   Never shown to logged-in customers or browsers that already gave an email.

   Events (auto-prefixed by BT.track): mobile_ask_view, mobile_ask_open,
   mobile_ask_submit, mobile_ask_dismiss, mobile_ask_try  — param trigger: bar | no_file
   Test: ?bt_mask=1 forces it on (any device, even unlocked); ?bt_mask=cover / ?bt_mask=bar
   force a style; ?bt_mask=0 turns it off. Event param trigger: cover | bar | no_file.
   ========================================================================== */
(function () {
  'use strict';
  if (window.BTMobileAsk) return;

  var root = document.querySelector('.bt[data-bt]');
  if (!root) return;

  var q = new URLSearchParams(location.search);
  var FORCE = /^(1|bar|cover)$/.test(q.get('bt_mask') || '');
  if (q.get('bt_mask') === '0') return;

  var cfgNode = root.querySelector('script[data-bt-mobile-ask]');
  if (!cfgNode && !FORCE) return;                       // not switched on for this tool

  var cfg = {};
  try { cfg = cfgNode ? JSON.parse(cfgNode.textContent) || {} : {}; } catch (e) { cfg = {}; }
  var lines = Array.isArray(cfg.copy) ? cfg.copy : [];
  function line(i, fallback) { var v = lines[i]; return v && String(v).trim() ? String(v).trim() : fallback; }

  var NAME = root.dataset.btName || document.title;
  var HANDLE = root.dataset.btTool || location.pathname.split('/').pop();
  var PREFIX = root.dataset.btPrefix || 'tool';

  // Style: line 4 of mobile_ask_copy = "cover" (full-screen on load, default) or "bar"
  // (slim strip). ?bt_mask=bar / ?bt_mask=cover override it for testing.
  var qm = q.get('bt_mask');
  var MODE = (qm === 'bar' || qm === 'cover') ? qm : (line(3, 'cover').toLowerCase() === 'bar' ? 'bar' : 'cover');
  var TEXT_HEAD = line(0, 'This tool works best on a computer');            // cover headline
  var TEXT_BAR = MODE === 'bar' ? line(0, 'Works best on a computer. Want the link?') : 'Works best on a computer. Want the link?';
  var TEXT_BTN = line(1, 'Email me the link');
  var TEXT_CARD = line(2, 'No file on this phone? We’ll email you a link to ' + NAME +
    ' so you can open it on your computer, plus free SVGs and new tools.');
  var TEXT_CARD_BAR = 'We’ll email you a link to ' + NAME +
    ' so you can open it on your computer, plus free SVGs and new tools.';
  var CONSENT = 'We’ll send crafting tips, free SVGs and new tools. Unsubscribe anytime.';

  var KLAVIYO_COMPANY = 'SCGZFP';
  var KLAVIYO_LIST = 'Si3Bsy';
  var KLAVIYO_REVISION = '2024-10-15';
  var LINK_METRIC = 'Requested Tool Link';
  var TIMEOUT = 4000;
  var COVER_DELAY = 1500;   // ms the visitor sees the tool before the cover fades in
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var EMAIL_KEYS = ['bt_email', 'ba_tools_email'];
  var FLAG_KEYS = ['ps_unlocked', 'ba_tools_unlocked'];
  var SS_BAR = 'bt_mask_bar_' + HANDLE;   // bar closed / used this visit
  var SS_CARD = 'bt_mask_card_' + HANDLE; // no-file card shown this visit
  var SS_COVER = 'bt_mask_cover_' + HANDLE; // cover shown this visit (then it lives on as the bar)
  var TOKENS = ['--bt-accent', '--bt-on-accent', '--bt-surface', '--bt-surface-2', '--bt-ink',
    '--bt-muted', '--bt-line', '--bt-shadow', '--bt-focus'];

  // ---------- who sees it ----------
  function isPhone() {
    try {
      return matchMedia('(max-width: 960px)').matches && matchMedia('(pointer: coarse)').matches;
    } catch (e) { return false; }
  }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function unlocked() {
    if (window.BT && typeof window.BT.isUnlocked === 'function') { try { if (window.BT.isUnlocked()) return true; } catch (e) {} }
    var c = window.BT_CUSTOMER;
    if (c && c.email) return true;
    if (EMAIL_KEYS.some(function (k) { return ls(k); })) return true;
    return FLAG_KEYS.some(function (k) { return ls(k) === '1'; });
  }
  if (!FORCE && (!isPhone() || unlocked())) return;

  function track(name, p) {
    try { if (window.BT && window.BT.track) window.BT.track(name, p || {}); } catch (e) {}
  }

  // ---------- Klaviyo ----------
  function klaviyoPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); return r; });
  }
  function toolUrl() {
    return location.origin + location.pathname +
      '?utm_source=klaviyo&utm_medium=email&utm_campaign=mobile_ask_link&utm_content=' + encodeURIComponent(HANDLE);
  }
  // Saved on the profile so the tool-list welcome flow (triggered by joining the list,
  // where event details aren't available) can send the right link.
  function linkProps(extra) {
    return Object.assign(extra, {
      requested_tool: NAME,
      requested_tool_url: toolUrl(),
      requested_tool_at: new Date().toISOString()
    });
  }
  function subscribe(email, trigger) {
    var source = 'Bearly Tools - ' + NAME + ' (mobile ask)';
    var props = linkProps({ first_tool: NAME });
    // Through the core when it's there, so a failed signup is saved and retried later.
    var sub = (window.BT && typeof window.BT.subscribe === 'function')
      ? window.BT.subscribe(email, { source: source, properties: props })
      : klaviyoPost('subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
        }
      });
    // The link email flow is triggered by this event (works for people already on the list too).
    var ev = klaviyoPost('events', {
      data: {
        type: 'event',
        attributes: {
          properties: { tool: NAME, tool_handle: HANDLE, tool_url: toolUrl(), trigger: trigger },
          metric: { data: { type: 'metric', attributes: { name: LINK_METRIC } } },
          profile: { data: { type: 'profile', attributes: { email: email, properties: linkProps({}) } } }
        }
      }
    });
    return Promise.all([sub.catch(function () {}), ev.catch(function () {})]);
  }
  function withTimeout(p, ms) {
    return new Promise(function (resolve) {
      var t = setTimeout(resolve, ms);
      p.then(function () { clearTimeout(t); resolve(); }, function () { clearTimeout(t); resolve(); });
    });
  }
  function unlockEverywhere(email) {
    EMAIL_KEYS.forEach(function (k) { ls(k, email); });
    FLAG_KEYS.forEach(function (k) { ls(k, '1'); });
  }

  // ---------- styles (one <style>, injected once) ----------
  function css() {
    if (document.getElementById('bt-mask-css')) return;
    var s = document.createElement('style');
    s.id = 'bt-mask-css';
    s.textContent =
      '.bt-mask-bar{position:fixed;left:8px;right:8px;z-index:9993;display:flex;align-items:center;gap:8px;' +
        'padding:8px 6px 8px 14px;border-radius:16px;font-family:inherit;box-sizing:border-box;' +
        'background:var(--bt-surface,#fff);color:var(--bt-ink,#1f1a1c);border:1px solid var(--bt-line,#e6e1e3);' +
        'box-shadow:0 8px 28px rgba(0,0,0,.18);transition:transform .25s ease,opacity .2s ease}' +
      '.bt-mask-bar[data-pos="bottom"]{bottom:calc(10px + env(safe-area-inset-bottom))}' +
      /* inside the phone editor: a small laptop tab on the left edge, clear of the tool's
         top controls and the bottom dock */
      '.bt-mask-bar[data-pos="tab"]{left:0;right:auto;top:calc(96px + env(safe-area-inset-top));gap:0;padding:0;border-left:0;border-radius:0 16px 16px 0;' +
        'box-shadow:0 6px 22px rgba(0,0,0,.22)}' +
      '.bt-mask-bar[data-pos="tab"] .bt-mask-bar__t,.bt-mask-bar[data-pos="tab"] .bt-mask-bar__x,' +
        '.bt-mask-bar[data-pos="tab"] .bt-mask-bar__lbl{display:none}' +
      '.bt-mask-bar[data-pos="tab"] .bt-mask-bar__go{display:grid;place-items:center;width:48px;height:52px;padding:0;border-radius:0 15px 15px 0}' +
      '.bt-mask-bar__ic{display:none}' +
      '.bt-mask-bar[data-pos="tab"] .bt-mask-bar__ic{display:block;width:26px;height:26px}' +
      '.bt-mask-bar.is-gone[data-pos="bottom"]{transform:translateY(140%);opacity:0;pointer-events:none}' +
      '.bt-mask-bar.is-gone[data-pos="tab"]{transform:translateX(-120%);opacity:0;pointer-events:none}' +
      '.bt-mask-bar__t{flex:1 1 auto;min-width:0;margin:0;font-size:14px;font-weight:600;line-height:1.3}' +
      '.bt-mask-bar__go{flex:none;margin:0;padding:9px 13px;border-radius:12px;border:0;cursor:pointer;font:inherit;font-size:14px;' +
        'font-weight:700;white-space:nowrap;letter-spacing:normal;text-transform:none;background:var(--bt-accent,#E8537A);color:var(--bt-on-accent,#fff)}' +
      '.bt-mask-bar__x,.bt-mask__x{flex:none;display:grid;place-items:center;width:34px;height:34px;margin:0;padding:0;border:0;' +
        'border-radius:999px;background:transparent;color:inherit;opacity:.55;font:400 22px/1 system-ui,sans-serif;cursor:pointer}' +
      '.bt-mask{position:fixed;inset:0;z-index:2147482990;display:flex;align-items:flex-end;justify-content:center;padding:12px;' +
        'padding-bottom:calc(12px + env(safe-area-inset-bottom));background:rgba(15,12,14,.5);font-family:inherit;box-sizing:border-box}' +
      '.bt-mask *,.bt-mask *::before,.bt-mask *::after{box-sizing:border-box}' +
      '.bt-mask__card{position:relative;width:100%;max-width:440px;padding:24px 20px 18px;border-radius:20px;' +
        'background:var(--bt-surface,#fff);color:var(--bt-ink,#1f1a1c);border:1px solid var(--bt-line,#e6e1e3);' +
        'box-shadow:var(--bt-shadow,0 20px 50px rgba(0,0,0,.25))}' +
      '.bt-mask__x{position:absolute;top:8px;right:8px}' +
      '.bt-mask__title{margin:0 0 6px;padding-right:30px;font-size:20px;font-weight:800;line-height:1.2;letter-spacing:normal;text-transform:none;color:inherit}' +
      '.bt-mask__msg{margin:0 0 14px;font-size:15px;line-height:1.45;color:var(--bt-muted,#6b6468)}' +
      '.bt-mask__email{display:block;width:100%;margin:0 0 10px;padding:12px 13px;border-radius:12px;font:inherit;font-size:16px;' +
        'border:1px solid var(--bt-line,#e6e1e3);background:var(--bt-surface-2,#f4f1f2);color:var(--bt-ink,#1f1a1c)}' +
      '.bt-mask__email::placeholder{color:var(--bt-muted,#6b6468);opacity:.6}' +
      '.bt-mask__email:focus{outline:none;border-color:var(--bt-accent,#E8537A);box-shadow:var(--bt-focus,0 0 0 3px rgba(232,83,122,.25))}' +
      '.bt-mask__go{display:block;width:100%;margin:0;padding:13px 16px;border-radius:12px;border:0;cursor:pointer;font:inherit;font-size:16px;' +
        'font-weight:700;letter-spacing:normal;text-transform:none;background:var(--bt-accent,#E8537A);color:var(--bt-on-accent,#fff)}' +
      '.bt-mask__go:disabled{opacity:.55;cursor:not-allowed}' +
      '.bt-mask__try{display:block;width:100%;margin:8px 0 0;padding:11px;border:0;border-radius:12px;background:transparent;cursor:pointer;' +
        'font:inherit;font-size:15px;font-weight:600;color:var(--bt-ink,#1f1a1c);text-decoration:underline;text-underline-offset:3px}' +
      '.bt-mask__err{margin:-4px 0 10px;font-size:13px;font-weight:600;color:#D93A3A}' +
      '.bt-mask__err[hidden],.bt-mask__form[hidden],.bt-mask__try[hidden]{display:none}' +
      '.bt-mask__fine{margin:10px 0 0;font-size:12px;line-height:1.4;color:var(--bt-muted,#6b6468)}' +
      '.bt-mask__sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}' +
      /* cover: full-screen white-out on load */
      '.bt-mask--cover{align-items:center;background:var(--bt-surface,#fff);' +
        'padding:calc(56px + env(safe-area-inset-top)) 20px calc(24px + env(safe-area-inset-bottom));overflow-y:auto;' +
        'animation:bt-mask-in .6s ease both}' +
      '.bt-mask--cover .bt-mask__card{animation:bt-mask-up .6s ease .1s both}' +
      '.bt-mask--cover .bt-mask__card{max-width:400px;padding:0;border:0;box-shadow:none;background:transparent;text-align:center;position:static}' +
      '.bt-mask--cover .bt-mask__x{position:fixed;top:calc(10px + env(safe-area-inset-top));right:12px;width:40px;height:40px;font-size:26px}' +
      '.bt-mask__icon{display:grid;place-items:center;width:72px;height:72px;margin:0 auto 18px;border-radius:20px;' +
        'background:var(--bt-surface-2,#f4f1f2);color:var(--bt-accent,#E8537A)}' +
      '.bt-mask__icon svg{width:40px;height:40px}' +
      '.bt-mask--cover .bt-mask__title{padding:0;font-size:26px;margin-bottom:10px}' +
      '.bt-mask--cover .bt-mask__msg{font-size:16px;margin-bottom:22px}' +
      '.bt-mask--cover .bt-mask__email{text-align:center}' +
      '.bt-mask--cover .bt-mask__try{margin-top:12px;padding:13px 16px;border:1px solid var(--bt-line,#e6e1e3);' +
        'background:var(--bt-surface,#fff);text-decoration:none;font-weight:700;font-size:16px}' +
      '@keyframes bt-mask-in{from{opacity:0}to{opacity:1}}' +
      '@keyframes bt-mask-up{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:none}}' +
      '@media (prefers-reduced-motion:reduce){.bt-mask-bar{transition:none}.bt-mask--cover,.bt-mask--cover .bt-mask__card{animation:none}}';
    document.head.appendChild(s);
  }
  function copyTokens(el) {
    try {
      var cs = getComputedStyle(root);
      TOKENS.forEach(function (t) { var v = cs.getPropertyValue(t); if (v && v.trim()) el.style.setProperty(t, v.trim()); });
    } catch (e) {}
  }

  // ---------- state ----------
  var bar = null, card = null, started = false, submitted = false, bootAt = 0;

  // ---------- the bar ----------
  function barPos() { return root.hasAttribute('data-app') ? 'tab' : 'bottom'; }
  function showBar() {
    if (bar || started || submitted || (!FORCE && ss(SS_BAR) === '1')) return;
    css();
    bar = document.createElement('div');
    bar.className = 'bt-mask-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Get the link for your computer');
    bar.dataset.pos = barPos();
    bar.innerHTML =
      '<p class="bt-mask-bar__t"></p>' +
      '<button type="button" class="bt-mask-bar__go">' +
        '<svg class="bt-mask-bar__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
          'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="4.5" width="16" height="11" rx="1.5"/>' +
          '<path d="M2 19.5h20"/></svg><span class="bt-mask-bar__lbl"></span></button>' +
      '<button type="button" class="bt-mask-bar__x" aria-label="Close"><span aria-hidden="true">×</span></button>';
    bar.querySelector('.bt-mask-bar__t').textContent = TEXT_BAR;
    bar.querySelector('.bt-mask-bar__lbl').textContent = TEXT_BTN;
    bar.querySelector('.bt-mask-bar__go').setAttribute('aria-label', TEXT_BTN + ' (works best on a computer)');
    copyTokens(bar);
    bar.querySelector('.bt-mask-bar__go').addEventListener('click', function () {
      track('mobile_ask_open', { trigger: 'bar' });
      openCard('bar');
    });
    bar.querySelector('.bt-mask-bar__x').addEventListener('click', function () {
      ss(SS_BAR, '1');
      track('mobile_ask_dismiss', { trigger: 'bar' });
      hideBar();
    });
    document.body.appendChild(bar);
    track('mobile_ask_view', { trigger: 'bar' });
    // In the phone editor the bar becomes a small left-edge tab (the tool's controls own the
    // top, the dock owns the bottom).
    // Not watching data-started: tools that load a demo (Sticker Sheet) hide their upload
    // card on load, which sets it before the visitor has touched anything. Starting is
    // judged only from the visitor's own events (onEvent below).
    try {
      new MutationObserver(function () { if (bar) bar.dataset.pos = barPos(); })
        .observe(root, { attributes: true, attributeFilter: ['data-app'] });
    } catch (e) {}
  }
  function hideBar() {
    if (!bar) return;
    var b = bar;
    bar = null;
    b.classList.add('is-gone');
    setTimeout(function () { b.remove(); }, 300);
  }

  // ---------- the card (email form) ----------
  function openCard(trigger) {
    if (card || submitted) return;
    css();
    var uid = 'bt-mask-' + Date.now().toString(36);
    card = document.createElement('div');
    var cover = trigger === 'cover';
    card.className = 'bt-mask' + (cover ? ' bt-mask--cover' : '');
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-modal', 'true');
    card.setAttribute('aria-labelledby', uid + '-t');
    card.innerHTML =
      '<div class="bt-mask__card">' +
        '<button type="button" class="bt-mask__x" aria-label="Close"><span aria-hidden="true">×</span></button>' +
        (cover ? '<div class="bt-mask__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4.5" width="16" height="11" rx="1.5"/>' +
          '<path d="M2 19.5h20"/></svg></div>' : '') +
        '<h2 class="bt-mask__title" id="' + uid + '-t"></h2>' +
        '<p class="bt-mask__msg" aria-live="polite"></p>' +
        '<form class="bt-mask__form" novalidate>' +
          '<label class="bt-mask__sr" for="' + uid + '-e">Email address</label>' +
          '<input class="bt-mask__email" id="' + uid + '-e" type="email" autocomplete="email" inputmode="email" placeholder="you@example.com">' +
          '<p class="bt-mask__err" role="alert" hidden></p>' +
          '<button class="bt-mask__go" type="submit"></button>' +
          '<p class="bt-mask__fine"></p>' +
        '</form>' +
        '<button type="button" class="bt-mask__try">Try it now</button>' +
      '</div>';
    var el = {
      title: card.querySelector('.bt-mask__title'),
      msg: card.querySelector('.bt-mask__msg'),
      form: card.querySelector('form'),
      input: card.querySelector('input'),
      err: card.querySelector('.bt-mask__err'),
      go: card.querySelector('.bt-mask__go'),
      tryBtn: card.querySelector('.bt-mask__try'),
      x: card.querySelector('.bt-mask__x')
    };
    el.title.textContent = cover ? TEXT_HEAD : trigger === 'no_file' ? 'Open it on your computer?' : 'Send this tool to your computer';
    el.msg.textContent = trigger === 'no_file' ? TEXT_CARD : TEXT_CARD_BAR;
    if (cover) el.tryBtn.textContent = 'Try it on my phone';
    el.go.textContent = TEXT_BTN;
    card.querySelector('.bt-mask__fine').textContent = CONSENT;
    copyTokens(card);

    var lastFocus = document.activeElement, done = false;
    function close(how) {
      if (done) return;
      done = true;
      removeEventListener('keydown', onKey, true);
      card.remove();
      card = null;
      if (how) track(how, { trigger: trigger });
      if (cover) { ss(SS_COVER, '1'); if (how && !submitted) showBar(); }   // cover shrinks into the bar
      else if (how === 'mobile_ask_try') { ss(SS_BAR, '1'); hideBar(); }
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus(); } catch (e) {} }
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); close('mobile_ask_dismiss'); }
    }
    el.x.addEventListener('click', function () { close('mobile_ask_dismiss'); });
    el.tryBtn.addEventListener('click', function () { close(submitted ? '' : 'mobile_ask_try'); });
    // Backdrop tap closes the small card; the cover only closes by its buttons (no accidental taps).
    if (!cover) card.addEventListener('click', function (e) { if (e.target === card) close('mobile_ask_dismiss'); });
    addEventListener('keydown', onKey, true);

    el.form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (el.go.disabled) return;
      var email = (el.input.value || '').trim().toLowerCase();
      if (!EMAIL_RE.test(email)) {
        el.err.textContent = 'Enter a full email address, like name@example.com.';
        el.err.hidden = false;
        el.input.focus();
        return;
      }
      el.err.hidden = true;
      el.go.disabled = true;
      el.go.textContent = 'Sending…';
      withTimeout(subscribe(email, trigger), TIMEOUT).then(function () {
        submitted = true;
        unlockEverywhere(email);
        track('mobile_ask_submit', { trigger: trigger });
        hideBar();
        el.title.textContent = 'Sent! Check your inbox';
        el.msg.textContent = 'Open the email on your computer to use ' + NAME + '. Your downloads here are unlocked too.';
        el.form.hidden = true;
        el.tryBtn.textContent = 'Keep going on my phone';
        el.tryBtn.hidden = false;
        setTimeout(function () { close(''); }, 6000);
      });
    });

    document.body.appendChild(card);
    if (cover) { var x = el.x; try { x.focus({ preventScroll: true }); } catch (e) {} }  // no keyboard popping up on load
    else el.input.focus();
  }

  // ---------- the cover (full-screen on load) ----------
  function showCover() {
    if (card || started || submitted) return;
    if (!FORCE && ss(SS_COVER) === '1') { showBar(); return; }   // already seen this visit: just the bar
    track('mobile_ask_view', { trigger: 'cover' });
    openCard('cover');
  }

  // ---------- started using the tool → fold the bar away ----------
  // Not a start: views, the tool's demo loading itself, navigation, the kit's own UI.
  var IGNORE = /_(\w*_view|demo_loaded|related_click|back_click|fullscreen_(on|off)|mobile_ask_\w+|upsell_\w+|file_rejected|app_\w+|email_\w+|progress_cancel)$/;
  function onEvent(name) {
    if (started || typeof name !== 'string') return;
    if (name.indexOf(PREFIX + '_') !== 0 || IGNORE.test(name)) return;
    if (Date.now() - bootAt < 1500 && !/_file_upload$/.test(name)) return; // tool's own load-time events
    started = true;
    hideBar();
  }
  function hookDataLayer() {
    var dl = window.dataLayer = window.dataLayer || [];
    if (dl.push && dl.push._btMask) return;
    var orig = dl.push;
    var wrapped = function () {
      for (var i = 0; i < arguments.length; i++) { var it = arguments[i]; if (it && it.event) onEvent(it.event); }
      return orig.apply(this, arguments);
    };
    wrapped._btMask = true;
    dl.push = wrapped;
  }

  // ---------- no file on this phone: picker opened, closed with nothing ----------
  var pickerAt = 0, picked = false, checkTimer = null;
  function noFile() {
    if (started || submitted || card || pickerAt === 0) return;
    pickerAt = 0;
    if (!FORCE && ss(SS_CARD) === '1') return;
    ss(SS_CARD, '1');
    track('mobile_ask_view', { trigger: 'no_file' });
    openCard('no_file');
  }
  function watchPicker() {
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.tagName === 'INPUT' && t.type === 'file') { pickerAt = Date.now(); picked = false; }
    }, true);
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.tagName === 'INPUT' && t.type === 'file') {
        picked = !!(t.files && t.files.length);
        if (picked) pickerAt = 0;
      }
    }, true);
    // Modern iOS/Android fire 'cancel' on the input when the picker is closed with nothing.
    root.addEventListener('cancel', function (e) {
      var t = e.target;
      if (t && t.tagName === 'INPUT' && t.type === 'file' && pickerAt) setTimeout(noFile, 250);
    }, true);
    // Fallback: the page comes back to the front and no file arrived.
    function back() {
      if (!pickerAt || document.visibilityState === 'hidden') return;
      clearTimeout(checkTimer);
      checkTimer = setTimeout(function () {
        if (pickerAt && !picked && Date.now() - pickerAt > 600) noFile();
      }, 900);
    }
    addEventListener('focus', back);
    document.addEventListener('visibilitychange', back);
  }

  // ---------- start ----------
  var running = false;
  function start() {
    if (running) return;
    running = true;
    bootAt = Date.now();
    hookDataLayer();
    watchPicker();
    // Cover: let them see the tool first, then fade in. Skipped if they start using it
    // or open the file picker in the meantime.
    if (MODE === 'cover') setTimeout(function () { if (!pickerAt) showCover(); }, COVER_DELAY);
    else showBar();
  }
  window.BTMobileAsk = { open: function () { openCard('bar'); }, version: 1 };
  if (window.BT && window.BT.ready) start();
  else {
    document.addEventListener('bt:ready', start, { once: true });
    addEventListener('load', function () { setTimeout(start, 1500); });   // backstop if core never boots
  }
})();